import Immutable from 'immutable';
import { SELECTED_TAB_CHANGED } from '../actions/tabList';

const SELECTED_TAB = 'selectedTab';

export default function selectedTab(state = Immutable.Map(), action) {
    switch (action.type) {
        case SELECTED_TAB_CHANGED:
            if (action.payload.panelId) {
                return state.setIn([action.payload.panelId.toString()], action.payload.tab);
            }

            return state;
        default:
            return state;
    }
}

export const selectedTabSelector = (state, id) => {
    if (id) {
        return state.getIn([SELECTED_TAB, id.toString()]);
    }

    return null;
};
